import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "./common.css";

// Custom input component
const CustomInput = forwardRef(({ value, onClick, onFocus, onBlur }, ref) => {
  return (
    <input
      ref={ref}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      value={value}
      readOnly
      className="custom-datepicker textPurple fs-09"
      style={{
        fontSize: "10px",
        maxWidth: "180px",
        cursor: "pointer",
        background: "transparent",
      }}
      placeholder="Select date"
    />
  );
});

const DateRangePicker = ({
  onChange,
  onCalendarOpen,
  onCalendarClose,
  onFocus,
  onBlur,
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (onChange) onChange({ start, end });
  };

  // Format the value for display in input
  const getDisplayValue = () => {
    if (startDate && endDate) {
      return `${format(startDate, "dd MMM")} - ${format(
        endDate,
        "dd MMM yyyy"
      )}`;
    } else if (startDate) {
      return `${format(startDate, "dd MMM yyyy")}`;
    } else {
      return "";
    }
  };

  return (
    <DatePicker
      selected={startDate}
      onChange={handleChange}
      startDate={startDate}
      className="fs-12 fw-400 "
      endDate={endDate}
      selectsRange
      isClearable
      customInput={
        <CustomInput
          value={getDisplayValue()}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      }
      onCalendarOpen={onCalendarOpen}
      onCalendarClose={onCalendarClose}
    />
  );
};

export default DateRangePicker;
